import { render, staticRenderFns } from "./BranceUpgrade.vue?vue&type=template&id=160d70b6"
import script from "./BranceUpgrade.vue?vue&type=script&lang=js"
export * from "./BranceUpgrade.vue?vue&type=script&lang=js"
import style0 from "./BranceUpgrade.vue?vue&type=style&index=0&id=160d70b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports